"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'GET_LOCATION':
      return {
        loading: true
      };

    case 'SUCCESS':
      return {
        position: {
          lat: action.lat,
          lng: action.lng
        }
      };

    case 'ERROR':
      return {
        error: action.error
      };

    default:
      return state;
  }
};

var useGeolocation = function useGeolocation(onError) {
  var _useReducer = (0, _react.useReducer)(reducer, {}),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var t = (0, _useTranslation["default"])();
  var getLocation = (0, _react.useCallback)(function () {
    var _window, _window$navigator, _window$navigator$geo;

    if (typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$geo = _window$navigator.geolocation) === null || _window$navigator$geo === void 0 ? void 0 : _window$navigator$geo.getCurrentPosition)) {
      var _window$navigator$geo2, _window$navigator$geo3;

      dispatch({
        type: 'GET_LOCATION'
      });

      var handleSuccess = function handleSuccess(position) {
        var _ref = (position === null || position === void 0 ? void 0 : position.coords) || {},
            _ref$latitude = _ref.latitude,
            latitude = _ref$latitude === void 0 ? 0 : _ref$latitude,
            _ref$longitude = _ref.longitude,
            longitude = _ref$longitude === void 0 ? 0 : _ref$longitude;

        dispatch({
          type: 'SUCCESS',
          lat: latitude,
          lng: longitude
        });
      };

      var handleError = function handleError(error) {
        onError === null || onError === void 0 ? void 0 : onError('Geolocation failed', {
          severity: 'info',
          metaData: {
            error: error
          }
        });
        dispatch({
          error: error,
          type: 'ERROR'
        });
      };

      (_window$navigator$geo2 = (_window$navigator$geo3 = window.navigator.geolocation).getCurrentPosition) === null || _window$navigator$geo2 === void 0 ? void 0 : _window$navigator$geo2.call(_window$navigator$geo3, handleSuccess, handleError);
      return;
    }

    dispatch({
      type: 'ERROR',
      error: {
        code: 2,
        message: t('cannot_geolocate')
      }
    });
  }, [t]);
  return [state, getLocation];
};

__signature__(useGeolocation, "useReducer{[state, dispatch]({})}\nuseTranslation{t}\nuseCallback{getLocation}", function () {
  return [_useTranslation["default"]];
});

var _default = useGeolocation;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(reducer, "reducer", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeolocation.ts");
  reactHotLoader.register(useGeolocation, "useGeolocation", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeolocation.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeolocation.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();